import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import {
  IApiResponse,
  IOrderDto,
} from '../models';
import { KeyValue } from '@angular/common';

@Injectable()
export class SearchService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public searchOrder(
    model: KeyValue<number, string>
  ): Observable<IApiResponse<IOrderDto>> {
    return this.post(`admin/search/order`, model);
  }
}
